import { SITEGLUE_INDUSTRY_OPTIONS } from "~/lib/siteglue/industry-business-outcomes";

export type SiteGlueIndustryNavItem = {
  /** Intake / canonical industry label */
  label: (typeof SITEGLUE_INDUSTRY_OPTIONS)[number];
  /** Short nav label when space is tight */
  navLabel: string;
  href: string;
  description: string;
};

/** SiteGlue-supported industries — one dedicated landing page each. */
export const SITEGLUE_INDUSTRIES_NAV: SiteGlueIndustryNavItem[] = [
  {
    label: "Healthcare",
    navLabel: "Healthcare",
    href: "/healthcare",
    description: "Patient communication, intake, and scheduling support.",
  },
  {
    label: "Dental & Orthodontics",
    navLabel: "Dental",
    href: "/dental",
    description: "New-patient inquiries, appointments, and front-desk coverage.",
  },
  {
    label: "Legal Services",
    navLabel: "Legal",
    href: "/legal",
    description: "Client intake, lead qualification, and consultation scheduling.",
  },
  {
    label: "Home Services",
    navLabel: "Home Services",
    href: "/home-services",
    description: "Job requests, dispatch intake, and service scheduling.",
  },
  {
    label: "Physical Therapy & Chiropractic",
    navLabel: "Physical Therapy",
    href: "/physical-therapy",
    description: "Patient scheduling, retention, and front-desk workflows.",
  },
  {
    label: "Real Estate",
    navLabel: "Real Estate",
    href: "/real-estate",
    description: "Buyer and seller leads, showings, and follow-up.",
  },
  {
    label: "Financial Services & Insurance",
    navLabel: "Financial Services",
    href: "/financial-services",
    description: "Prospect qualification, appointments, and client communications.",
  },
  {
    label: "Education & Private Schools",
    navLabel: "Education",
    href: "/education",
    description: "Admissions inquiries, enrollment, and family communications.",
  },
  {
    label: "Nonprofits & Churches",
    navLabel: "Nonprofits & Churches",
    href: "/nonprofits-and-churches",
    description: "Donors, volunteers, events, and community engagement.",
  },
  {
    label: "Retail & E-Commerce",
    navLabel: "Retail & E-Commerce",
    href: "/retail",
    description: "Sales support, order questions, and customer service.",
  },
];

export const SITEGLUE_INDUSTRIES_NAV_LABEL = "Industries";
export const SITEGLUE_INDUSTRIES_MEGA_TITLE = "Industries";
export const SITEGLUE_INDUSTRIES_MEGA_LINE =
  "Dedicated AI Employee solutions for every industry SiteGlue supports.";
export const SITEGLUE_INDUSTRIES_SEE_ALL_HREF = "/ai-employees";
